import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import GoogleMapReact from "google-map-react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import * as dateFormat from "dateformat";
import Box from "../components/Box";
import PropertyLabel from "../components/PropertyLabel";
import ErrorMessage from "../components/ErrorMessage";
import MachineStatusBadge from "../components/MachineStatusBadge";
import { history } from "../store";
import MachineMarker from "../components/MachineMarker";
import RemoteActionsList from "../components/RemoteActionsList";
import MachineStockTable from "../components/MachineStockTable";
import MoneyTable from "../components/MoneyTable";
import MachinePromoterFeesTable from "../components/MachinePromoterFeesTable";

import RemoteActionAddForm from "../forms/RemoteActionAddForm";
import { deleteMachine, fetchMachine } from "../actions/machines";
import {
  getMachinePicture,
  getMachineCoordinates,
  getMachineStatus,
  getMachineStatusColor,
} from "../utils/machines";
import { fetchRemoteActions } from "../actions/remoteactions";
import { fetchShifts } from "../actions/shifts";
import { fetchPromoters } from "../actions/promoters";
import { GMAPS_KEY } from "../config";
import SecurityBoxTable from "../components/SecurityBoxTable";

import { fetchMatrixs } from "../actions/matrixs";
import MatrixConstructor from "../components/MatrixConstructor";
import MatrixConstructorAdmin from "../components/MatrixConstructorAdmin";
import MatrixConstructorSignal from "../components/MatrixConstructorSignal";
import MatrixConstructorBattery from "../components/MatrixConstructorBattery";
import MatrixConstructorVersion from "../components/MatrixConstructorVersion";
import MatrixConstructorBLEOff from "../components/MatrixConstructorBLEOff";
import AssignedModuleList from "../components/AssignedModuleList";
import AssignedPairingList from "../components/AssignedPairingList";
import AssignedPaymentDevicesList from "../components/AssignedPaymentDevicesList";

import "../styles/MachinesAdminView.css";

class MachineDetailsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      deleting: false,
      deleteConfirmShown: false,
      showModules: false,
      showPairing: false,
      showPaymentDevices: false,
      activeTab: "2",
      adminActiveTab: "config",
      pageTab: "general",
    };

    this.toggle = this.toggle.bind(this);
    this.toggleAdmin = this.toggleAdmin.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteConfirmShow = this.deleteConfirmShow.bind(this);
    this.deleteConfirmToggle = this.deleteConfirmToggle.bind(this);
    this.downloadAgenczia = this.downloadAgenczia.bind(this);

    this.createMatrix = this.createMatrix.bind(this);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleAdmin(tab) {
    if (this.state.adminActiveTab !== tab) {
      this.setState({ adminActiveTab: tab });
    }
  }

  goTo(e) {
    history.push(`/matrixs/:Serial`);
  }

  componentDidMount() {
    const { fetchMachine, fetchRemoteActions, fetchMatrixs, fetchShifts, match } =
      this.props;

    fetchMachine(match.params.id);
    fetchMatrixs("");
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.deleting && !nextProps.machines.machine) {
      this.props.push("/machines");
    }

    const prevMachine = this.props.machines && this.props.machines.machine;
    const nextMachine = nextProps.machines && nextProps.machines.machine;
    if (!prevMachine && nextMachine) {
      this.props.fetchRemoteActions(nextMachine.Serial);
      
      // Fetch recent shifts (last 30 days)
      // Note: Fetch all shifts without machine filter since API expects ObjectId not Serial
      // We'll filter by machine Serial in the render method
      const endDate = new Date().toISOString().substring(0, 10);
      const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10);
      this.props.fetchShifts(undefined, undefined, startDate, endDate);
    }
  }

  delete() {
    const {
      deleteMachine,
      machines: { machine },
    } = this.props;

    this.setState({ deleting: true });
    deleteMachine(machine._id);
  }

  deleteConfirmShow() {
    this.setState({ deleteConfirmShown: true });
  }

  deleteConfirmToggle() {
    this.setState({ deleteConfirmShown: !this.state.deleteConfirmShown });
  }

  downloadAgenczia() {
    const {
      machines: { machine },
    } = this.props;

    const dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(machine.Agenczia_della_entrate.data));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute(
      "download",
      "agenczia_della_entrate" + ".json",
    );
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  getPayments(tipo) {
    switch (tipo) {
      case 0: {
        return "TPV + CASH";
      }
      case 1: {
        return "CASH";
      }
      case 2: {
        return "TPV";
      }
      case 3: {
        return "RFID";
      }
    }
  }

  createMatrix() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructor matrixs={matrixs} machine={machine} />;
  }

  createMatrixAdmin() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructorAdmin matrixs={matrixs} machine={machine} />;
  }

  createMatrixBattery() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructorBattery matrixs={matrixs} machine={machine} />;
  }

  createMatrixSignal() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructorSignal matrixs={matrixs} machine={machine} />;
  }

  createMatrixVersion() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructorVersion matrixs={matrixs} machine={machine} />;
  }

  createMatrixBLEOff() {
    const {
      matrixs,
      machines: { machine },
      error,
      loading,
    } = this.props;

    if (!matrixs) {
      return (
        <div class="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    return <MatrixConstructorBLEOff matrixs={matrixs} machine={machine} />;
  }

  renderPromoterActivity(machine, shifts) {
    if (!shifts || shifts.loading) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    if (shifts.error) {
      return <ErrorMessage message={shifts.error.message} />;
    }

    const shiftsList = shifts.shifts || [];
    const machineSerial = machine.Serial;

    // Filter shifts for this specific machine only
    const machineShifts = shiftsList.filter(shift => {
      if (!shift.machine) return false;
      // shift.machine could be a string (Serial) or an object with Serial property
      const shiftMachineSerial = typeof shift.machine === 'string' 
        ? shift.machine 
        : (shift.machine.Serial || '');
      return shiftMachineSerial === machineSerial;
    });

    // Group shifts by promoter and then by day
    const promoterShifts = {};
    const now = new Date();
    const today = now.toISOString().substring(0, 10);

    machineShifts.forEach(shift => {
      const promoterName = shift.workerName || 'Unknown';
      if (!promoterShifts[promoterName]) {
        promoterShifts[promoterName] = {
          name: promoterName,
          workingDays: {},
          currentlyWorking: false
        };
      }
      
      const shiftDate = new Date(shift.date);
      const shiftDay = shiftDate.toISOString().substring(0, 10);
      
      // Group shifts by day
      if (!promoterShifts[promoterName].workingDays[shiftDay]) {
        promoterShifts[promoterName].workingDays[shiftDay] = {
          date: shiftDay,
          shifts: []
        };
      }
      
      promoterShifts[promoterName].workingDays[shiftDay].shifts.push({
        date: shift.date,
        time: shiftDate
      });

      // Check if working today
      if (shiftDay === today) {
        promoterShifts[promoterName].currentlyWorking = true;
      }
    });

    // Process each promoter's working days
    Object.values(promoterShifts).forEach(promoter => {
      Object.keys(promoter.workingDays).forEach(day => {
        const dayData = promoter.workingDays[day];
        // Sort shifts by time
        dayData.shifts.sort((a, b) => a.time - b.time);
        
        // Get first and last shift of the day
        const firstShift = dayData.shifts[0].time;
        const lastShift = dayData.shifts[dayData.shifts.length - 1].time;
        
        dayData.startTime = firstShift.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
        dayData.endTime = lastShift.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
        dayData.displayDate = firstShift.toLocaleDateString('es-ES', { weekday: 'short', day: '2-digit', month: 'short', timeZone: 'UTC' });
        dayData.shiftCount = dayData.shifts.length;
        
        // Calculate total hours worked
        const hoursDiff = (lastShift - firstShift) / (1000 * 60 * 60);
        dayData.hoursWorked = hoursDiff.toFixed(1);
      });
    });

    const promotersList = Object.values(promoterShifts).sort((a, b) => 
      a.name.localeCompare(b.name)
    );

    if (promotersList.length === 0) {
      return (
        <div style={{ 
          padding: 'clamp(16px, 4vw, 20px)', 
          textAlign: 'center', 
          color: '#64748b' 
        }}>
          <i className="fas fa-calendar-times" style={{ 
            fontSize: 'clamp(32px, 8vw, 48px)', 
            marginBottom: '10px' 
          }}></i>
          <p style={{ fontSize: 'clamp(0.8rem, 2vw, 0.9rem)' }}>
            No se encontraron registros de promotores en los últimos 30 días
          </p>
        </div>
      );
    }

    // Generate calendar days for the last 30 days
    const calendarDays = [];
    const endDate = new Date();
    const startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
    
    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      calendarDays.push(new Date(d).toISOString().substring(0, 10));
    }

    return (
      <div style={{ padding: 'clamp(8px, 2vw, 10px) 0' }}>
        {promotersList.map(promoter => {
          const workingDaysArray = Object.values(promoter.workingDays).sort((a, b) => 
            new Date(b.date) - new Date(a.date)
          );

          return (
            <div key={promoter.name} style={{ 
              marginBottom: 'clamp(18px, 3vw, 25px)', 
              padding: 'clamp(14px, 3vw, 20px)', 
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              {/* Header */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                marginBottom: '15px',
                flexWrap: 'wrap',
                gap: '10px'
              }}>
                <h4 style={{ 
                  margin: 0, 
                  color: '#1e293b',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  flexWrap: 'wrap',
                  fontSize: 'clamp(0.95rem, 2vw, 1.1rem)'
                }}>
                  <i className="fas fa-user-circle" style={{ color: '#0a4080' }}></i>
                  <span>{promoter.name}</span>
                  <span style={{ 
                    fontSize: 'clamp(0.7rem, 1.5vw, 0.8rem)', 
                    fontWeight: '400', 
                    color: '#64748b'
                  }}>
                    ({workingDaysArray.length} días trabajados)
                  </span>
                </h4>
                {promoter.currentlyWorking && (
                  <span style={{
                    padding: '6px 14px',
                    backgroundColor: '#22c55e',
                    color: 'white',
                    borderRadius: '12px',
                    fontSize: 'clamp(0.65rem, 1.5vw, 0.75rem)',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    whiteSpace: 'nowrap'
                  }}>
                    <i className="fas fa-circle" style={{ fontSize: '8px', animation: 'pulse 2s infinite' }}></i>
                    Trabajando hoy
                  </span>
                )}
              </div>

              {/* Calendar Graph */}
              <div style={{ marginBottom: '15px' }}>
                <div style={{ 
                  fontSize: 'clamp(0.65rem, 1.8vw, 0.75rem)', 
                  color: '#64748b',
                  marginBottom: '8px',
                  fontWeight: '500'
                }}>
                  <i className="fas fa-calendar-alt"></i> Calendario de trabajo (últimos 30 días)
                </div>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(20px, 1fr))',
                  gap: 'clamp(2px, 0.5vw, 4px)',
                  padding: 'clamp(8px, 2vw, 10px)',
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  border: '1px solid #e2e8f0',
                  maxWidth: '100%',
                  overflow: 'hidden'
                }}>
                  {calendarDays.map(day => {
                    const hasWorked = promoter.workingDays[day];
                    const isToday = day === today;
                    const date = new Date(day);
                    const dayOfWeek = date.getDay();
                    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

                    return (
                      <div
                        key={day}
                        title={hasWorked 
                          ? `${date.toLocaleDateString('es-ES')} - ${hasWorked.startTime} a ${hasWorked.endTime} (${hasWorked.hoursWorked}h)`
                          : date.toLocaleDateString('es-ES')
                        }
                        style={{
                          width: '100%',
                          aspectRatio: '1',
                          minWidth: '16px',
                          maxWidth: '24px',
                          borderRadius: '4px',
                          backgroundColor: hasWorked 
                            ? (isToday ? '#22c55e' : '#0ea5e9')
                            : (isWeekend ? '#f1f5f9' : 'white'),
                          border: isToday 
                            ? '2px solid #16a34a' 
                            : (hasWorked ? '1px solid #0284c7' : '1px solid #e2e8f0'),
                          cursor: hasWorked ? 'pointer' : 'default',
                          transition: 'all 0.2s',
                          boxShadow: hasWorked ? '0 1px 2px rgba(0,0,0,0.1)' : 'none'
                        }}
                        onMouseEnter={(e) => {
                          if (hasWorked) {
                            e.currentTarget.style.transform = 'scale(1.2)';
                            e.currentTarget.style.zIndex = '10';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (hasWorked) {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.zIndex = '1';
                          }
                        }}
                      />
                    );
                  })}
                </div>
                <div style={{ 
                  display: 'flex', 
                  gap: 'clamp(8px, 2vw, 15px)', 
                  marginTop: '8px',
                  fontSize: 'clamp(0.6rem, 1.5vw, 0.7rem)',
                  color: '#64748b',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#0ea5e9', borderRadius: '2px', flexShrink: 0 }}></div>
                    Día trabajado
                  </span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#22c55e', border: '2px solid #16a34a', borderRadius: '2px', flexShrink: 0 }}></div>
                    Hoy
                  </span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '2px', flexShrink: 0 }}></div>
                    Sin actividad
                  </span>
                </div>
              </div>

              {/* Working Days List */}
              <div style={{ 
                fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)', 
                color: '#64748b',
                marginBottom: '8px',
                fontWeight: '500'
              }}>
                <i className="fas fa-list"></i> Jornadas de trabajo
              </div>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))',
                gap: '10px' 
              }}>
                {workingDaysArray.slice(0, 15).map((day, idx) => (
                  <div key={idx} style={{
                    padding: 'clamp(10px, 2vw, 12px)',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)'
                  }}>
                    <div style={{ 
                      fontWeight: '600', 
                      color: '#0a4080',
                      marginBottom: '6px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '6px'
                    }}>
                      <span>{day.displayDate}</span>
                      <span style={{ 
                        fontSize: 'clamp(0.6rem, 1.5vw, 0.7rem)', 
                        color: '#64748b',
                        fontWeight: '400',
                        whiteSpace: 'nowrap'
                      }}>
                        {day.shiftCount} {day.shiftCount === 1 ? 'login' : 'logins'}
                      </span>
                    </div>
                    <div style={{ 
                      color: '#64748b', 
                      display: 'flex', 
                      gap: 'clamp(4px, 1vw, 8px)', 
                      alignItems: 'center',
                      flexWrap: 'wrap'
                    }}>
                      <span style={{ whiteSpace: 'nowrap' }}>
                        <i className="fas fa-sign-in-alt" style={{ fontSize: '0.85em' }}></i> {day.startTime}
                      </span>
                      <span>→</span>
                      <span style={{ whiteSpace: 'nowrap' }}>
                        <i className="fas fa-sign-out-alt" style={{ fontSize: '0.85em' }}></i> {day.endTime}
                      </span>
                    </div>
                    <div style={{ 
                      marginTop: '4px',
                      fontSize: 'clamp(0.6rem, 1.5vw, 0.7rem)',
                      color: '#0ea5e9',
                      fontWeight: '500'
                    }}>
                      <i className="fas fa-clock"></i> {day.hoursWorked}h trabajadas
                    </div>
                  </div>
                ))}
              </div>
              
              {workingDaysArray.length > 15 && (
                <div style={{ 
                  marginTop: '10px', 
                  fontSize: '12px', 
                  color: '#64748b',
                  fontStyle: 'italic',
                  textAlign: 'center'
                }}>
                  + {workingDaysArray.length - 15} días más
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const {
      role,
      type,
      machines,
      machines: { machine },
      remoteActions,
    } = this.props;
    const { pageTab, activeTab } = this.state;

    if (machines.error) {
      return <ErrorMessage message={machines.error.message} />;
    }

    if (!machine || machines.loading) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    // Cash data helpers
    const bills = machine.Bills_in_box || { five: 0, ten: 0, twenty: 0 };
    const coins = machine.Cash_in_box || { fifty: 0, one: 0, two: 0, token: 0 };
    const secBox = machine.Bills_in_security_box || {
      five: 0,
      ten: 0,
      twenty: 0,
    };
    const stock = machine.Stock_machine || {};

    const billsTotal =
      (bills.five || 0) * 5 + (bills.ten || 0) * 10 + (bills.twenty || 0) * 20;
    const coinsTotal =
      (coins.fifty || 0) * 0.5 + (coins.one || 0) * 1 + (coins.two || 0) * 2;
    const secTotal =
      (secBox.five || 0) * 5 +
      (secBox.ten || 0) * 10 +
      (secBox.twenty || 0) * 20;

    return (
      <div className="machines-admin-view od-machine-detail">
        {/* ── Header ── */}
        <div className="mach-admin-header od-header-detail">
          <div className="od-header-left">
            <div className="od-header-icon">
              <i className="fas fa-desktop"></i>
            </div>
            <div className="od-header-info">
              <div className="od-header-title">
                <span className="od-header-product">VACWAYone</span>
                <span className="od-header-serial">{machine.Serial}</span>
              </div>
              <div className="od-header-meta">
                <span
                  className="od-header-status-badge"
                  style={{ background: getMachineStatusColor(machine) }}
                >
                  {getMachineStatus(machine)}
                </span>
                <span className="od-header-meta-item">
                  <i className="fas fa-clock"></i>
                  Última conexión:&nbsp;
                  <strong>
                    {machine.Last_signal
                      ? new Date(machine.Last_signal).toLocaleString("es-ES", {
                          timeZone: "Europe/Madrid",
                          hour12: false,
                        })
                      : "—"}
                  </strong>
                </span>
              </div>
            </div>
          </div>
          <div className="header-actions">
            {role === "ADMIN" && type === "MASTER" && (
              <Link
                to={`/machines/${machine._id}/edit`}
                className="mach-admin-btn bg-info text-white"
              >
                <i className="fas fa-edit"></i>
                <span className="d-none d-sm-inline">Editar</span>
              </Link>
            )}
          </div>
        </div>

        {/* ── Page-level tab bar ── */}
        <div className="od-page-nav">
          {[
            { id: "general", icon: "fa-desktop", label: "General" },
            { id: "cajas", icon: "fa-cash-register", label: "Cajas" },
            ...(role === "ADMIN"
              ? [
                  {
                    id: "promotores",
                    icon: "fa-users",
                    label: "Promotores",
                  },
                  {
                    id: "config",
                    icon: "fa-sliders-h",
                    label: "Configuración",
                  },
                  {
                    id: "remote",
                    icon: "fa-terminal",
                    label: "Acciones Remotas",
                  },
                ]
              : []),
          ].map((t) => (
            <button
              key={t.id}
              className={`od-page-tab${pageTab === t.id ? " active" : ""}`}
              onClick={() => this.setState({ pageTab: t.id })}
            >
              <i className={`fas ${t.icon}`}></i>
              <span>{t.label}</span>
            </button>
          ))}
        </div>

        {/* ═══ TAB: GENERAL ═══ */}
        {pageTab === "general" && (
          <div className="od-general-grid">
            {/* Machine image card */}
            <div className="od-hero-image od-grid-image">
              <img
                src={getMachinePicture(machine.Type)}
                alt="Máquina"
                className="od-machine-img"
              />
            </div>

            {/* Consumibles / Stock */}
            {(() => {
              const items = [
                {
                  key: "VWPACK",
                  label: "Pack",
                  img: "/images/machines/pack.avif",
                  color: "#2563eb",
                  max: 300,
                },
                {
                  key: "VWLAY",
                  label: "Lay",
                  img: "/images/machines/lay.avif",
                  color: "#16a34a",
                  max: 120,
                },
                {
                  key: "VWGO",
                  label: "Go!",
                  img: "/images/machines/go.avif",
                  color: "#dc2626",
                  max: 15,
                },
              ];
              return (
                <div className="od-stock-inline od-grid-stock">
                  <div className="od-stock-inline-hd">
                    <i className="fas fa-box-open"></i> Consumibles
                  </div>
                  <div className="od-stock-bar-list">
                    {items.map((item) => {
                      const val = stock[item.key] || 0;
                      const pct = Math.min(
                        100,
                        Math.round((val / item.max) * 100),
                      );
                      const fillColor =
                        pct > 50
                          ? item.color
                          : pct > 20
                            ? "#f59e0b"
                            : "#ef4444";
                      return (
                        <div key={item.key} className="od-stock-bar-row">
                          <div className="od-stock-bar-meta">
                            <img
                              src={item.img}
                              alt={item.label}
                              className="od-stock-bar-img"
                            />
                            <span className="od-stock-bar-label">
                              {item.label}
                            </span>
                            <span className="od-stock-bar-count">
                              {val}{" "}
                              <span className="od-stock-bar-max">
                                / {item.max}
                              </span>
                            </span>
                            <span
                              className="od-stock-bar-pct"
                              style={{ color: fillColor }}
                            >
                              {pct}%
                            </span>
                          </div>
                          <div className="od-stock-bar-track">
                            <div
                              className="od-stock-bar-fill"
                              style={{
                                width: `${pct}%`,
                                background: fillColor,
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* Info chips */}
            <div className="od-info-grid od-grid-chips">
              {/* Pagos — col1 row1 */}
              <div className="od-info-chip" style={{ "--chip-color": "#1d4ed8" }}>
                <div className="od-chip-icon">
                  <i className="fas fa-cash-register"></i>
                </div>
                <div>
                  <span className="od-chip-label">Método de pago</span>
                  <span className="od-chip-val">
                    {this.getPayments(machine.PaymentMethods)}
                  </span>
                  <span className="od-chip-sub">
                    <i className="fas fa-coins fa-xs"></i>
                    Fondo inicial: {machine.ChangeInitial} €
                  </span>
                  <span className="od-chip-sub">
                    <i className="fas fa-ban fa-xs"></i>
                    Máx. cobro cash: {machine.CashMax} €
                  </span>
                </div>
              </div>

              {/* Sleep — col2 row1 */}
              <div className="od-info-chip" style={{ "--chip-color": "#7c3aed" }}>
                <div className="od-chip-icon">
                  <i className="fas fa-moon"></i>
                </div>
                <div>
                  <span className="od-chip-label">Horario Sleep</span>
                  <span className="od-chip-val">
                    {machine.SleepStart} h → {machine.SleepEnd} h
                  </span>
                  <span className="od-chip-sub">
                    <i className="fas fa-stopwatch fa-xs"></i>
                    Timeout pantalla: {machine.AutoScreenExitTime} s
                  </span>
                </div>
              </div>

              {/* Credenciales — col3 row1 */}
              <div className="od-info-chip" style={{ "--chip-color": "#dc2626" }}>
                <div className="od-chip-icon">
                  <i className="fas fa-key"></i>
                </div>
                <div>
                  <span className="od-chip-label">Credenciales</span>
                  <span className="od-chip-sub">
                    <i className="fas fa-desktop fa-xs"></i>
                    Máquina: <strong>{machine.PasswordMachine}</strong>
                  </span>
                  <span className="od-chip-sub">
                    <i className="fas fa-dollar-sign fa-xs"></i>
                    Cash: <strong>{machine.PasswordCash}</strong>
                  </span>
                  {role === "ADMIN" && (
                    <span className="od-chip-sub">
                      <i className="fas fa-crown fa-xs"></i>
                      Master: <strong>{machine.PasswordMaster}</strong>
                    </span>
                  )}
                </div>
              </div>

              {/* Idioma — col4 row1 */}
              <div className="od-info-chip" style={{ "--chip-color": "#0f766e" }}>
                <div className="od-chip-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <div>
                  <span className="od-chip-label">Idioma</span>
                  <span className="od-chip-val">{machine.Language || "—"}</span>
                  {machine.videoAllowed && (
                    <span className="od-chip-sub">
                      <i className="fas fa-play-circle fa-xs"></i>
                      Vídeo publicitario activado
                    </span>
                  )}
                  {machine.GeneralSoundActive && (
                    <span className="od-chip-sub">
                      <i className="fas fa-volume-up fa-xs"></i>
                      Sonido activado
                    </span>
                  )}
                </div>
              </div>

              {/* Cliente — col1 row2 */}
              {machine.Customer && (
                <div className="od-info-chip" style={{ "--chip-color": "#059669" }}>
                  <div className="od-chip-icon">
                    <i className="fas fa-building"></i>
                  </div>
                  <div>
                    <span className="od-chip-label">Cliente</span>
                    <span className="od-chip-val">{machine.Customer.Fullname}</span>
                    {machine.Contract && (
                      <span className="od-chip-sub">
                        <i className="fas fa-file-contract fa-xs"></i>
                        Contrato #{machine.Contract.number}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {/* Modelo — col2 row2 */}
              <div className="od-info-chip" style={{ "--chip-color": "#475569" }}>
                <div className="od-chip-icon">
                  <i className="fas fa-cube"></i>
                </div>
                <div>
                  <span className="od-chip-label">Modelo</span>
                  <span className="od-chip-val">{machine.Type || "—"}</span>
                  <span className="od-chip-sub">
                    <i className="fas fa-calendar-alt fa-xs"></i>
                    Fabricación:{" "}
                    {machine.Build_date
                      ? new Date(machine.Build_date).toLocaleDateString("es-ES")
                      : "—"}
                  </span>
                  {machine.EthernetMode && (
                    <span className="od-chip-sub">
                      <i className="fas fa-ethernet fa-xs"></i>
                      Modo Ethernet
                    </span>
                  )}
                </div>
              </div>

              {/* Promotor — col3 row2 (if present; shifts Versiones/Token right) */}
              {machine.Promoter && (
                <div className="od-info-chip" style={{ "--chip-color": "#db2777" }}>
                  <div className="od-chip-icon">
                    <i className="fas fa-user-tie"></i>
                  </div>
                  <div>
                    <span className="od-chip-label">Promotor</span>
                    <span className="od-chip-val">
                      {machine.Promoter.name} {machine.Promoter.surname}
                    </span>
                    <span className="od-chip-sub od-mono">
                      <i className="fas fa-id-badge fa-xs"></i>
                      Código: {machine.Promoter.password}
                    </span>
                  </div>
                </div>
              )}

              {/* Versiones — second-to-last */}
              {role === "ADMIN" && (
                <div className="od-info-chip" style={{ "--chip-color": "#0891b2" }}>
                  <div className="od-chip-icon">
                    <i className="fas fa-code-branch"></i>
                  </div>
                  <div>
                    <span className="od-chip-label">Versiones</span>
                    <span className="od-chip-sub">
                      <i className="fas fa-laptop-code fa-xs"></i>
                      SW: <strong>{machine.Sw_version}</strong>
                    </span>
                    <span className="od-chip-sub">
                      <i className="fas fa-microchip fa-xs"></i>
                      FW: <strong>{machine.Fw_version}</strong>
                    </span>
                    <span className="od-chip-sub">
                      <i className="fas fa-sync fa-xs"></i>
                      Updater: <strong>{machine.Up_version}</strong>
                    </span>
                  </div>
                </div>
              )}

              {/* Token — last */}
              {role === "ADMIN" && (
                <div className="od-info-chip" style={{ "--chip-color": "#d97706" }}>
                  <div className="od-chip-icon">
                    <i className="fas fa-fingerprint"></i>
                  </div>
                  <div>
                    <span className="od-chip-label">Token de máquina</span>
                    <span className="od-chip-val od-mono od-truncate">
                      {machine.Token}
                    </span>
                    <span className="od-chip-sub">
                      <i className="fas fa-terminal fa-xs"></i>
                      {machine.Executor}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ═══ TAB: CAJAS ═══ */}
        {pageTab === "cajas" && (
          <div className="od-cajas-page">
            {/* Summary strip */}
            <div className="od-cash-summary">
              {[
                {
                  label: "Billetes en caja",
                  icon: "fa-file-invoice-dollar",
                  value: billsTotal,
                  color: "#0a4080",
                },
                {
                  label: "Monedas en caja",
                  icon: "fa-coins",
                  value: coinsTotal,
                  color: "#0891b2",
                },
                {
                  label: "Caja de seguridad",
                  icon: "fa-lock",
                  value: secTotal,
                  color: "#7c3aed",
                },
                {
                  label: "Total recaudado",
                  icon: "fa-euro-sign",
                  value: billsTotal + coinsTotal + secTotal,
                  color: "#16a34a",
                  big: true,
                },
              ].map((s) => (
                <div
                  key={s.label}
                  className={`od-cs-card${s.big ? " od-cs-total" : ""}`}
                  style={{ "--cc": s.color }}
                >
                  <div className="od-cs-icon">
                    <i className={`fas ${s.icon}`}></i>
                  </div>
                  <div className="od-cs-inner">
                    <span className="od-cs-label">{s.label}</span>
                    <span className="od-cs-amount">{s.value.toFixed(2)} €</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Detail boxes */}
            <div className="od-cash-boxes">
              {/* Bills */}
              <div className="od-cash-box">
                <div className="od-cash-box-hd">
                  <i className="fas fa-file-invoice-dollar"></i> Caja de
                  Billetes
                </div>
                <div className="od-denom-grid">
                  {[
                    { label: "5 €", count: bills.five || 0, mult: 5 },
                    { label: "10 €", count: bills.ten || 0, mult: 10 },
                    { label: "20 €", count: bills.twenty || 0, mult: 20 },
                  ].map((d) => (
                    <div key={d.label} className="od-denom-card">
                      <div className="od-denom-pill">{d.label}</div>
                      <div className="od-denom-count">{d.count}</div>
                      <div className="od-denom-value">
                        {(d.count * d.mult).toFixed(2)} €
                      </div>
                    </div>
                  ))}
                  <div className="od-denom-card od-denom-total">
                    <div className="od-denom-pill">TOTAL</div>
                    <div className="od-denom-count">
                      {(bills.five || 0) +
                        (bills.ten || 0) +
                        (bills.twenty || 0)}
                    </div>
                    <div className="od-denom-value">
                      {billsTotal.toFixed(2)} €
                    </div>
                  </div>
                </div>
              </div>

              {/* Coins */}
              <div className="od-cash-box">
                <div className="od-cash-box-hd">
                  <i className="fas fa-coins"></i> Caja de Monedas
                </div>
                <div className="od-denom-grid">
                  {[
                    { label: "0.50 €", count: coins.fifty || 0, mult: 0.5 },
                    { label: "1 €", count: coins.one || 0, mult: 1 },
                    { label: "2 €", count: coins.two || 0, mult: 2 },
                  ].map((d) => (
                    <div
                      key={d.label}
                      className={`od-denom-card${d.isToken ? " od-denom-token" : ""}`}
                    >
                      <div className="od-denom-pill">{d.label}</div>
                      <div className="od-denom-count">{d.count}</div>
                      <div className="od-denom-value">
                        {d.isToken ? "—" : `${(d.count * d.mult).toFixed(2)} €`}
                      </div>
                    </div>
                  ))}
                  <div className="od-denom-card od-denom-total">
                    <div className="od-denom-pill">TOTAL</div>
                    <div className="od-denom-count">
                      {(coins.fifty || 0) + (coins.one || 0) + (coins.two || 0)}
                    </div>
                    <div className="od-denom-value">
                      {coinsTotal.toFixed(2)} €
                    </div>
                  </div>
                </div>
              </div>

              {/* Security box */}
              <div className="od-cash-box">
                <div className="od-cash-box-hd">
                  <i className="fas fa-lock"></i> Caja de Seguridad
                </div>
                <div className="od-denom-grid">
                  {[
                    { label: "5 €", count: secBox.five || 0, mult: 5 },
                    { label: "10 €", count: secBox.ten || 0, mult: 10 },
                    { label: "20 €", count: secBox.twenty || 0, mult: 20 },
                  ].map((d) => (
                    <div key={d.label} className="od-denom-card">
                      <div className="od-denom-pill">{d.label}</div>
                      <div className="od-denom-count">{d.count}</div>
                      <div className="od-denom-value">
                        {(d.count * d.mult).toFixed(2)} €
                      </div>
                    </div>
                  ))}
                  <div className="od-denom-card od-denom-total">
                    <div className="od-denom-pill">TOTAL</div>
                    <div className="od-denom-count">
                      {(secBox.five || 0) +
                        (secBox.ten || 0) +
                        (secBox.twenty || 0)}
                    </div>
                    <div className="od-denom-value">
                      {secTotal.toFixed(2)} €
                    </div>
                  </div>
                </div>
                <div className="od-secbox-actions">
                  <SecurityBoxTable machine={this.props.machines.machine} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ═══ TAB: PROMOTORES (admin) ═══ */}
        {pageTab === "promotores" && role === "ADMIN" && (
          <div className="od-general-grid" style={{ gridTemplateColumns: '1fr' }}>
            <Box title="Actividad de Promotores" icon="users">
              {this.renderPromoterActivity(machine, this.props.shifts)}
            </Box>
          </div>
        )}

        {/* ═══ TAB: CONFIGURACIÓN (admin) ═══ */}
        {pageTab === "config" && role === "ADMIN" && (
          <div className="od-config-page">
            <div className="od-config-columns">
              {/* Col 1 — Información + Sleep */}
              <div className="od-config-col">
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-info-circle"></i> Información
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Token</span>
                      <span className="od-prop-v od-mono od-truncate">
                        {machine.Token}
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Password master</span>
                      <span className="od-prop-v">{machine.PasswordMaster}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Fabricación</span>
                      <span className="od-prop-v">
                        {new Date(machine.Build_date).toLocaleDateString("es-ES")}
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">SW</span>
                      <span className="od-prop-v">
                        <span className="od-ver-badge">{machine.Sw_version}</span>
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">FW</span>
                      <span className="od-prop-v">
                        <span className="od-ver-badge">{machine.Fw_version}</span>
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Updater</span>
                      <span className="od-prop-v">
                        <span className="od-ver-badge">{machine.Up_version}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-moon"></i> Sleep
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Inicio</span>
                      <span className="od-prop-v">{machine.SleepStart} h</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Fin</span>
                      <span className="od-prop-v">{machine.SleepEnd} h</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Col 2 — Máquina + Dispositivos */}
              <div className="od-config-col">
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-cog"></i> Máquina
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Pagos</span>
                      <span className="od-prop-v">
                        {this.getPayments(machine.PaymentMethods)}
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Idioma</span>
                      <span className="od-prop-v">{machine.Language}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Timeout</span>
                      <span className="od-prop-v">{machine.AutoScreenExitTime}s</span>
                    </div>
                    {machine.videoAllowed && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Video</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                    {machine.Reset_no_internet && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Reset sin internet</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                    {machine.Enable_standby && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Stand-by</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                    {machine.EthernetMode && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Ethernet</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                    {machine.GeneralSoundActive && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Pasos sonoros</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                    {machine.PackSale && (
                      <div className="od-prop-row">
                        <span className="od-prop-k">Venta packs</span>
                        <span className="od-prop-v"><span className="od-flag-yes">SI</span></span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-puzzle-piece"></i> Dispositivos
                  </div>
                  <div className="od-prop-list">
                    {(this.props.machines.machine.PaymentDevices || []).map((device, i) => (
                      <div key={i} className="od-prop-row">
                        <span className="od-prop-k">{device.Type}</span>
                        <span className="od-prop-v">{device.Device}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Col 3 — Firmware */}
              <div className="od-config-col">
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-microchip"></i> Firmware
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Robot init speed</span>
                      <span className="od-prop-v">{machine.Robotctl_up_init_speed}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Robot empty steps</span>
                      <span className="od-prop-v">{machine.Robotctl_empty_steps}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Robot steps 100</span>
                      <span className="od-prop-v">{machine.Robotctl_steps_100_covers}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Robot pickup</span>
                      <span className="od-prop-v">{machine.Robotctl_pickup_movement}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Lid maxopen</span>
                      <span className="od-prop-v">{machine.Lidctl_st_maxopen_move}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Lid max move</span>
                      <span className="od-prop-v">{machine.Lidctl_max_move}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Seal min press</span>
                      <span className="od-prop-v">{machine.Sealctl_min_press_kpa}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Seal intensity</span>
                      <span className="od-prop-v">{machine.Sealctl_seal_intensity}</span>
                    </div>
                  </div>
                </div>
                {machine.TokenActivated && (
                  <div className="od-config-section">
                    <div className="od-config-section-hd">
                      <i className="fas fa-ticket-alt"></i> Token
                    </div>
                    <div className="od-prop-list">
                      <div className="od-prop-row">
                        <span className="od-prop-k">Valor token</span>
                        <span className="od-prop-v">{machine.Token_value} €</span>
                      </div>
                      <div className="od-prop-row">
                        <span className="od-prop-k">Valor venta</span>
                        <span className="od-prop-v">{machine.Token_sale_value} €</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Col 4 — Pagos Cash */}
              <div className="od-config-col">
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-euro-sign"></i> Pagos Cash
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Billetes aceptados</span>
                      <span className="od-prop-v">{machine.BillerAcceptance}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Cambio inicial</span>
                      <span className="od-prop-v">{machine.ChangeInitial} €</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Caja seguridad</span>
                      <span className="od-prop-v">
                        {(machine.SecurityBox || "").toString()}
                      </span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Máx devo diario</span>
                      <span className="od-prop-v">{machine.LimiteDevolucionDiario} €</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Máx devo de golpe</span>
                      <span className="od-prop-v">{machine.LimiteDevolucion} €</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Cobro máx Cash</span>
                      <span className="od-prop-v">{machine.CashMax} €</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Col 5 — TPV */}
              <div className="od-config-col">
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-credit-card"></i> TPV
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Nº serie</span>
                      <span className="od-prop-v">{machine.Tpv_serial}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">TCOD</span>
                      <span className="od-prop-v">{machine.Tpv_tcod}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Cargo máximo</span>
                      <span className="od-prop-v">{machine.Tpv_max} €</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Timeout cancelación</span>
                      <span className="od-prop-v">{machine.TpvCancelTime}s</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Código comercio</span>
                      <span className="od-prop-v">{machine.TpvBusinessCode}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Nº Terminal</span>
                      <span className="od-prop-v">{machine.TpvTerminalCode}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Clave Firma</span>
                      <span className="od-prop-v">{machine.TpvFirmKeyCode}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Integrations row (RFID mode only) ── */}
            {machine.PaymentMethods == 3 && (
              <div className="od-config-integrations">
                {/* Aquapalace */}
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-water"></i> Aquapalace
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Endpoint</span>
                      <span className="od-prop-v">{machine.Aquapalace.Endpoint}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Username</span>
                      <span className="od-prop-v">{machine.Aquapalace.Username}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">ComputerId</span>
                      <span className="od-prop-v">{machine.Aquapalace.ComputerId}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">DepartmentId</span>
                      <span className="od-prop-v">{machine.Aquapalace.DepartmentId}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">PackArticleId</span>
                      <span className="od-prop-v">{machine.Aquapalace.PackArticleId}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">LayArticleId</span>
                      <span className="od-prop-v">{machine.Aquapalace.LayArticleId}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">GoArticleId</span>
                      <span className="od-prop-v">{machine.Aquapalace.GoArticleId}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">PriceUnit</span>
                      <span className="od-prop-v">{machine.Aquapalace.PriceUnit}</span>
                    </div>
                  </div>
                </div>

                {/* LandOfLegends */}
                <div className="od-config-section">
                  <div className="od-config-section-hd">
                    <i className="fas fa-dragon"></i> Land of Legends
                  </div>
                  <div className="od-prop-list">
                    <div className="od-prop-row">
                      <span className="od-prop-k">Bearer</span>
                      <span className="od-prop-v od-mono od-truncate">{machine.LandOfLegends.Bearer}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">Endpoint</span>
                      <span className="od-prop-v">{machine.LandOfLegends.Endpoint}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">DEPID</span>
                      <span className="od-prop-v">{machine.LandOfLegends.DEPID}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">PRODUCTID_VWPACK</span>
                      <span className="od-prop-v">{machine.LandOfLegends.PRODUCTID_VWPACK}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">PRODUCTID_VWLAY</span>
                      <span className="od-prop-v">{machine.LandOfLegends.PRODUCTID_VWLAY}</span>
                    </div>
                    <div className="od-prop-row">
                      <span className="od-prop-k">PRODUCTID_VWGO</span>
                      <span className="od-prop-v">{machine.LandOfLegends.PRODUCTID_VWGO}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ═══ TAB: ACCIONES REMOTAS (admin) ═══ */}
        {pageTab === "remote" && role === "ADMIN" && (
          <div className="od-remote-page">
            {type === "MASTER" ? (
              <>
                <div className="od-remote-form-card">
                  <RemoteActionAddForm machine={machine} />
                </div>
                <div className="od-remote-list-card">
                  <RemoteActionsList remoteActions={remoteActions} />
                </div>
              </>
            ) : (
              <div className="od-empty-state">
                <i className="fas fa-lock fa-2x mb-2"></i>
                <p>No tienes permisos para ver acciones remotas.</p>
              </div>
            )}
          </div>
        )}

        {/* Confirm deletion modal */}
        <div>
          <Modal
            isOpen={this.state.deleteConfirmShown}
            toggle={this.deleteConfirmToggle}
          >
            <ModalHeader toggle={this.deleteConfirmToggle}>
              Confirmar
            </ModalHeader>
            <ModalBody>
              {machine.Customer ? (
                <p>
                  Una máquina no se puede borrar mientras tenga un contrato
                  asignado.
                </p>
              ) : (
                <p>¿Estás seguro de borrar la máquina?</p>
              )}
            </ModalBody>
            <ModalFooter>
              {!machine.Customer && (
                <Button color="primary mr-1" onClick={this.delete}>
                  Borrar
                </Button>
              )}
              <Button color="secondary" onClick={this.deleteConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  machines: state.machines,
  matrixs: state.matrixs.matrixs,
  error: state.machines.error,
  loading: state.machines.loading,
  remoteActions: state.remoteactions,
  shifts: state.shifts,
  role: state.auth.role,
  type: state.auth.type,
});

const mapDispatchToProps = (dispatch) => ({
  deleteMachine: bindActionCreators(deleteMachine, dispatch),
  fetchMachine: bindActionCreators(fetchMachine, dispatch),
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  fetchShifts: bindActionCreators(fetchShifts, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineDetailsView);
